import { 
    Loader,  
    useModal
 } from '@jutro/components';
import { useTranslator, IntlContext } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useAciUtil } from 'ent-capability-hooks';
import {
    getNormalizedLOBName,
    isCapabilityEnabled,
} from '@xengage/gw-portals-config-js';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
 
import appConfig from 'app-config';
import { PolicyService } from 'gw-capability-policy';
import {
    PolicyCommonContacts,
    PolicyCommonDetails,
    PolicyCommonDocuments,
    PolicyCoverages,
} from 'gw-capability-policy-common-react';
import {
    PaymentPlans,
    TurnOnAutopay,
    PaymentMethod,
    MakeAPayment,
} from 'ent-capability-billing-react';
import { OfferOfInsurance } from 'ent-capability-offers-react';
import { DocumentService } from 'gw-capability-policydocument';
import  { TwiaBillingService }  from 'ent-capability-policybilling';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import PolicyDetailsSummary from "twia-capability-policy-react/components/PolicyDetailsSummary/PolicyDetailsSummary";
import PolicyPrivacyDisclosure from "twia-capability-policy-react/components/PolicyPrivacyDisclosure/PolicyPrivacyDisclosure"
import messages from './PolicyDetails.messages';
import metadata from './PolicyDetails.metadata.json5';
import styles from './PolicyDetails.module.scss';

const handlePrint = () => {
    window.print();
};

const goToDocumentView = () => {
    let data = document.getElementById('renewalPolicyDocumentsContainer');

    if (_.isEmpty(data)) {
        data = document.getElementById('DocumentsAccordion');
    }

    data.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
    })

}

function PolicyDetails(props) {
    const { history, match, onResolve, onReject, onAfterClose } = props;
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const [policyCommonDetails, updatePolicyCommonDetails] = useState({
        currentPeriodDetails: {},
        renewedPeriodDetails: {},
        hasRenewedPeriod: false,
    });
    const [writableDocuments, updateWritableDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const translator = useTranslator();
    const [enableEdit, setEnableEdit] = useState(false);
    const [viewEditPayment, setViewEditPayment] = useState(false);
    const { capabilitiesConfig } = appConfig;
    const [/* calcFees */, setCalcFees] = useState(true);
    const url = _.get(match, 'params.policyNumber');
    const policyNumber = url?.split('&')[0];
    const [selectedPaymentInstrumentId, setSelectedPaymentInstrumentId] = useState('');
    const [selectedPaymentInstrument, setSelectedPaymentInstrument] = useState({});
    const [paymentInstruments, setPaymentInstruments] = useState([]);
    const [filteredPaymentInstruments, setFilteredPaymentInstruments] = useState([]); // single-use payment instruments filtered out when auto pay on
    const {
        filterPaymentInstruments, 
        getSyncedPaymentInstrumentsForAccount, 
        makeOfferPayment, 
        handleAddPaymentInstrumentError
    } = useAciUtil();
    const [paymentPlan, setPaymentPlan] = useState();
    const [baseAmount, setBaseAmount] = useState();
    const [showPrivacyPreviousValue, updateShowPrivacyPreviousValue] = useState();
    const [showPrivacyDisclosure, setShowPrivacyDisclosure] = useState(false);
    const [autoPay,updateAutoPay] = useState(false);
    const { showAlert } = useModal();

    const intl = useContext(IntlContext);

    const getFormattedDate = useCallback(
        (date) => intl.formatDate(new Date(date), {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            }),
        [intl]
    );

    const goToPaymentHistoryView = useCallback(() => {
        history.push('/billing-summary', { policyNumber })
    }, [history, policyNumber]
    );    

    const getPolicyDetails = useCallback(async () => {
        if (authHeader) {
            const policyDetails = await PolicyService.getAccountPolicyDetails(
                policyNumber,
                authHeader
            );

            // 2025-05-14 - SGoli - DE19172 - Amount to Pay doesn't include WPI-8 waiver surcharge when
            //   first navigating to Policy Details page
            // Initialize customer payment amount to the selected payment plan downpayment amount which includes
            // credits and surcharges
            if (policyDetails?.bindData_TWIA && policyDetails?.bindData_TWIA?.paymentPlans && policyDetails?.bindData_TWIA?.customerPaymentDetails_TWIA) {
                const plans = policyDetails.bindData_TWIA.paymentPlans;
                const currentplan = plans.find(plan => plan.billingId === policyDetails.bindData_TWIA.selectedPaymentPlan);

                policyDetails.bindData_TWIA.customerPaymentDetails_TWIA.amount = currentplan?.downPayment?.amount;
            }

            
            const searchParams = new URLSearchParams(window.location.search);

            let aState = searchParams?.get("state");        
            
            if(!_.isEmpty(policyDetails.renewedPeriod)){
                // get latest overriding PI from BC to know if the policy still has autopay
                await TwiaBillingService.getOverridingPaymentInstrument(policyNumber, authHeader)
               .then((overridePaymentInstrument) => {                    
                   
                   const val = !_.isUndefined(overridePaymentInstrument) && !_.isEmpty(overridePaymentInstrument)

                   _.set(policyDetails?.bindData_TWIA, 'customerPaymentDetails_TWIA.isAutoPayEnabled', val);
               })
           }

            const redirectBindData =policyDetails.bindData_TWIA ? policyDetails.bindData_TWIA : {};

            if (aState) {
                aState = JSON.parse(window.atob(window.decodeURIComponent(aState)));
              
                redirectBindData.selectedPaymentPlan = _.get(aState, 'paymentPlan');
                redirectBindData.customerPaymentDetails_TWIA.amount = _.get(aState, 'baseAmount');
                redirectBindData.customerPaymentDetails_TWIA.isAutoPayEnabled =  _.get(aState, 'autoPay');
                setEnableEdit(false)

            }

            updatePolicyCommonDetails({
                currentPeriodDetails: policyDetails.currentPeriod,
                privacyOptOut_TWIA: policyDetails.privacyOptOut_TWIA,
                renewedPeriodDetails: policyDetails.renewedPeriod
                    ? policyDetails.renewedPeriod
                    : {},
                hasRenewedPeriod: !_.isEmpty(policyDetails.renewedPeriod),
                isRenewalHasAutoPay: policyDetails.bindData_TWIA?.customerPaymentDetails_TWIA.isAutoPayEnabled && !_.isEmpty(policyDetails.renewedPeriod),
                bindData: redirectBindData
            });         

            
            setBaseAmount(policyDetails.bindData_TWIA?.customerPaymentDetails_TWIA.amount);
            setPaymentPlan(policyDetails.bindData_TWIA?.selectedPaymentPlan);
            
            if(!aState){
                const val = policyDetails.bindData_TWIA?.customerPaymentDetails_TWIA.isAutoPayEnabled && !_.isEmpty(policyDetails.renewedPeriod);

                setEnableEdit(val);
                setViewEditPayment(val);
            }

            const accountNumber = _.get(policyDetails, 'bindData_TWIA.accountNumber');
            const renewalOfferNumber = _.get(policyDetails, 'renewedPeriod.jobNumber_TWIA');
            
            // eslint-disable-next-line no-unused-expressions
            accountNumber && await getSyncedPaymentInstrumentsForAccount(accountNumber, authHeader).then(setPaymentInstruments);
            
            // 2025-03-03 - Debra Frum - DE18428 - DR01- CE - Payment method is not saved when auto-pay is selected 
            //                                     for payment plans other than 10 pay
            handleAddPaymentInstrumentError(accountNumber, renewalOfferNumber, searchParams, authHeader);

            setLoading(false);
        }
    }, [authHeader, policyNumber, getSyncedPaymentInstrumentsForAccount, handleAddPaymentInstrumentError]);

    const setPaymentInstrument = useCallback((instrument) => {
        setSelectedPaymentInstrumentId(instrument.publicID);
        setSelectedPaymentInstrument(instrument);

        _.set(policyCommonDetails?.bindData, 'customerPaymentDetails_TWIA.token', _.get(instrument, 'token'));
       
    },  [policyCommonDetails?.bindData, setSelectedPaymentInstrument]);

    const onSelectedInstrumentChange = useCallback((value) => {
        setSelectedPaymentInstrumentId(value);

        const instrument = paymentInstruments.find(pi => pi.publicID === value);

        setSelectedPaymentInstrument(instrument);
        setPaymentInstrument(instrument);
    },  [paymentInstruments, setPaymentInstrument]);

    const setAutoPay = useCallback((value) => {
        updateAutoPay(value);
        _.set(policyCommonDetails?.bindData, 'customerPaymentDetails_TWIA.isAutoPayEnabled', value);
        filterPaymentInstruments(value, paymentInstruments, setFilteredPaymentInstruments);
    },  [filterPaymentInstruments, paymentInstruments, policyCommonDetails?.bindData, setFilteredPaymentInstruments]);

    const handlePrivacyPolicyClick = useCallback(() => {
       setShowPrivacyDisclosure(!showPrivacyDisclosure)
       
       if(showPrivacyDisclosure && !_.isUndefined(showPrivacyPreviousValue)) {
        policyCommonDetails.privacyOptOut_TWIA.decision = showPrivacyPreviousValue;
       }
    },  [policyCommonDetails, showPrivacyDisclosure, showPrivacyPreviousValue]);

    const redirectToEndorsement = useCallback(
        (policyDetails, requestType) => {
            const productCode = _.findKey(
                policyDetails.lobs,
                lob => !_.isEmpty(lob)
            );

            history.push(`/endorsement-${getNormalizedLOBName(productCode)}`, {
                policyNumber,
                policyDetails,
                requestType,
            });
        },
        [history, policyNumber]
    );

    const canChangePolicy = useCallback(
        policyPeriod => {
            if (!_.isEmpty(policyPeriod)) {
                const productCode = _.findKey(
                    policyPeriod.lobs,
                    lob => !_.isEmpty(lob)
                );

                if (_.isEmpty(productCode)) {
                    return false;
                }

                return (
                    isCapabilityEnabled({
                        capabilitiesConfig,
                        capabilityName: 'policychange',
                        lob: productCode,
                    }) && policyPeriod.canBeChanged
                );
            }

            return false;
        },
        [capabilitiesConfig]
    );

    const getPolicyDownloadLink = useCallback(() => DocumentService.downloadPolicyDocument(
        _.get(policyCommonDetails.currentPeriodDetails, 'idCardPublicID'),
        _.get(policyCommonDetails.currentPeriodDetails, 'idCardSessionID')
    ), [policyCommonDetails]);


    const onClickMenuLink = useCallback(() => {
        setEnableEdit(false)
    }, [setEnableEdit]);

    // 2025-03-21 - Debra Frum - DE18878 - UAT - After paying for a renewal offer in CE, 
    //   the Submission Successful screen is not displaying
    // Define the function that routes to the Submission Successful Confirmation page
    // when the OK button on the Payment Confirmation page is clicked after payment
    // has been made and Offer is issued
    const onClickOk = useCallback((policyData) => {
        history.push({
            pathname: '/submission-successful',
            state: {
                policyData,
            },
        });
    }, [history]);
    
    const onMakePayment = useCallback(async () => {
        // 2025-02-02 - Debra Frum -  US25432 - CE - Policy Holds
        // Don't send payment if there is a policy hold or other blocking UW Issues
        const checkUWIssues = async () => {
            const renewaOfferNumber = policyCommonDetails.renewedPeriodDetails.jobNumber_TWIA;
            const uwIssueStatus = await CustomQuoteService.getUWIssueStatus(renewaOfferNumber, undefined, authHeader);

            if (uwIssueStatus.anyPolicyHoldUWIssues) {
                showAlert({
                    status: 'error',
                    title: messages.noTitle,
                    message: messages.errorPolicyHoldUW,
                });
            } else if (uwIssueStatus.anyOtherBlockingUWIssues) {
                showAlert({
                    status: 'error',
                    title: messages.noTitle,
                    message: messages.cantIssuePolicy,
                });
            } else {
                const config = {policyCommonDetails,setLoading,authHeader,onClickOk,onResolve,onReject,onAfterClose};

                makeOfferPayment(config);
             }
         };
 
         try {
             checkUWIssues();
         }
         catch (e) {
             _.noop()
         }
    
    }, [authHeader, showAlert, policyCommonDetails, onClickOk, onResolve, onReject, onAfterClose, makeOfferPayment])

    const isPolicyInForce = () => {
        if(!_.isEmpty(policyCommonDetails.currentPeriodDetails) && policyCommonDetails.currentPeriodDetails.lobs) {
        const policyStatus = policyCommonDetails.currentPeriodDetails.productCodeIdentifier_TWIA === 'Homeowners'?
        policyCommonDetails.currentPeriodDetails.lobs.homeOwners.status :
        policyCommonDetails.currentPeriodDetails.lobs.commercialProperty?.status;

        return policyStatus === 'In Force';
        }

        return false
    }

    useEffect(() => {
            try {
                getPolicyDetails();

            } catch (e) {
                throw new Error(e);
            }
    },
        // Only need to run once when initial page render and when documents are added/removed
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [authHeader]
    );

    const overrideProps = {
        pageTitle: {
            content: translator(messages.pageTitle, {
                policyNumber:
                    policyCommonDetails.currentPeriodDetails.policyNumber,
            }),
        },
        currentPeriod: {
            heading: translator(messages.currentTab),
        },
        renewalPeriod: {
            heading: policyCommonDetails.hasRenewedPeriod
                ? translator(messages.renewalTab)
                : '',
            disabled: !policyCommonDetails.hasRenewedPeriod,
        },
        tabviewContainerTFPA: {
           visible: !_.isUndefined(policyCommonDetails.currentPeriodDetails.status_TFPA)
        },
        tabviewContainer: {
            visible: _.isUndefined(policyCommonDetails.currentPeriodDetails.status_TFPA)
        },
        renewalTurnOnAutopay: {
            enableEdit,
            bindData: policyCommonDetails.bindData,
            paymentPlan, 
            payFrom: "offers",
            setAutoPay
        },
        renewalPaymentPlans: {
            enableEdit,
            payFrom: "offers",
            authHeader,
            offer: policyCommonDetails.renewedPeriodDetails,
            bindData: policyCommonDetails.bindData,
            baseAmount,
            setBaseAmount,
            paymentPlan, 
            setPaymentPlan,
            setCalcFees
        },
        renewalPaymentMethod: {
            enableEdit,
            payFrom: "offers",
            authHeader,
            offer: policyCommonDetails.renewedPeriodDetails,
            bindData: policyCommonDetails.bindData,
            accountNumberIdentifier : policyCommonDetails?.bindData?.accountNumber,
            selectedPaymentInstrument: setPaymentInstrument,
            paymentInstruments: filteredPaymentInstruments,
            onSelectedInstrumentChange,
            paymentInstrument: selectedPaymentInstrumentId,
            identifier: policyCommonDetails.renewedPeriodDetails.policyNumber,
            isAutoDraft : autoPay
        },
        editPaymentDetails: {
            visible: !_.isUndefined(viewEditPayment) && viewEditPayment && policyCommonDetails.hasRenewedPeriod 
        },
        headerEditPayment: {
            visible: !_.isUndefined(viewEditPayment) && viewEditPayment && policyCommonDetails.hasRenewedPeriod 
        },
        editPaymentBannerText:{
            content: translator(messages.editPaymentBanner, {
                draftDate: getFormattedDate(policyCommonDetails?.bindData?.paymentDueDate_TWIA),
            }),
        },
        policyChangeButtonContainer: {
            // Dont show Policy Change button in CE
            visible: false && canChangePolicy(
                policyCommonDetails.currentPeriodDetails,
                policyCommonDetails.currentPeriodDetails.productName
            ),
        },
        renewalPolicyChangeButtonContainer: {
            visible: canChangePolicy(
                policyCommonDetails.renewedPeriodDetails,
                policyCommonDetails.currentPeriodDetails.productName
            ),
        },
        idCardContainer: {
            visible: !_.isEmpty(
                _.get(
                    policyCommonDetails.currentPeriodDetails,
                    'idCardPublicID'
                )
            ),
        },
        idCard: {
            href: getPolicyDownloadLink(),
            target: '_blank',
        },
        policyDocumentsSection: {
            updateWritableDocuments,
            writableDocuments,
            onlyPNI: true,
            disableUpload: true,
        },
        policyPeriodTabSet: {
            defaultActiveTab: policyCommonDetails.hasRenewedPeriod ? 'renewalPeriod' : 'currentPeriod'
        },
        renewalOfferOfInsurance: {
            offer: policyCommonDetails.renewedPeriodDetails,
            bindData: policyCommonDetails.bindData
        },
        policyDetailsSummary: {
            policyCommonDetails,
            updateWritableDocuments,
            writableDocuments,
            isPolicyLevelDoc : true
        },
        privacyDisclosure1: {
            visible: showPrivacyDisclosure,
            showPrivacyDisclosure,
            updateShowPrivacyPreviousValue,
            showPrivacyPreviousValue,
            policyCommonDetails
        },
        privacyButtonContainer: {
           visible: isPolicyInForce()
        },
        renewalPolicyForRenewalPeriod: {
            policyCommonDetails,
            updateWritableDocuments,
            writableDocuments,
            isRenewal: true,
            isPolicyLevelDoc : true
        },
        renewalMakeAPayment: {
            onMakePayment,
            payFrom: "offers",
            policyNumber: policyCommonDetails.renewedPeriodDetails.policyNumber,
            authHeader, 
            manualAmountToPay: {amount: policyCommonDetails?.bindData?.customerPaymentDetails_TWIA?.amount, currency: 'usd'},
            paymentPlan, 
            calcFees: true,
            autoPay: _.get(policyCommonDetails.bindData, 'customerPaymentDetails_TWIA.isAutoPayEnabled'),
            accountNumberIdentifier: policyCommonDetails?.bindData?.accountNumber,
            identifier: policyCommonDetails.renewedPeriodDetails.policyNumber,
            paymentInstrument: selectedPaymentInstrument,
            currency : 'usd',
            setCalcFees,
            bindData: policyCommonDetails?.bindData,
            offer: { productCodeIdentifier_TWIA: 'Homeowners'},
            history,
        }
    };

    const resolvers = {
        resolveComponentMap: {
            policycommondetailscomponent: PolicyCommonDetails,
            policycoveragescomponent: PolicyCoverages,
            policycommondocumentscomponent: PolicyCommonDocuments,
            policycommoncontactscomponent: PolicyCommonContacts,
            offerofinsurance: OfferOfInsurance,
            paymentplans: PaymentPlans,
            turnonautopay: TurnOnAutopay,
            paymentmethod: PaymentMethod,
            makeapayment: MakeAPayment,
            policyDetailsSummary: PolicyDetailsSummary,
            policyPrivacyDisclosure: PolicyPrivacyDisclosure
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onPrint: handlePrint,
            onClickDocument: goToDocumentView,
            onHandlePrivacy: handlePrivacyPolicyClick,
            onClickPaymentHistory: goToPaymentHistoryView,
            onChangePolicy: () =>
                redirectToEndorsement(
                    policyCommonDetails.currentPeriodDetails,
                    'policyChange'
                ),
            onChangePolicyRenewal: () =>
                redirectToEndorsement(
                    policyCommonDetails.renewedPeriodDetails,
                    'policyRenew'
                ),
            onClickMenuLink
        },
    };

    return (
        <Loader loaded={!loading}>
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={policyCommonDetails}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
        </Loader>
    );
}

PolicyDetails.propTypes = {
    match: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
        productCode: PropTypes.string,
    }).isRequired,
};

export default withRouter(PolicyDetails);
